<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-10">
      <h4 style="text-indent: 30pt;">
        {{"module-assignment.basket_settings.basket_configurations" | translate }}
      </h4>
    </div>
    <mat-card-content style=" padding-left: 40px;">
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.restrict_refunds_for_same_tenders" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle
            id="matToggleRestrictRefundsForSameTenders"
            formControlName="restrictRefundsForSameTenders"
          >
          </mat-slide-toggle>
        </div>
      </div>
    </mat-card-content>
    <!-- Receipt Screen Configuration -->
    <mat-card-content style=" padding-left: 40px;">
      <h4>{{"module-assignment.basket_settings.receipt_screen_configuration" | translate }}</h4>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.email" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleReceiptEmail" formControlName="email"> </mat-slide-toggle>
        </div>
        <div fxFlex="70" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-form-field
            class="mat-block"
            id="matFrmFieldInteract"
            *ngIf="parentForm?.get(authControlKey)?.get('email').value"
          >
            <mat-select
              id="matFrmFieldInteract"
              formControlName="emailTemplateFormat"
              [placeholder]="'module-assignment.basket_settings.email_format' | translate"
            >
              <mat-option *ngFor="let item of EMAIL_FORMAT_TYPE " [value]="item.value">
                {{item.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.print" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleReceiptPrint" formControlName="print"> </mat-slide-toggle>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.reprintLimit" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle
            id="matToggleReprintLimit"
            formControlName="reprintLimit"
            (change)="reprintLimitToggleChange($event)"
          >
          </mat-slide-toggle>
        </div>
        <div fxFlex="70" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-form-field
            id="matFrmFieldReprintLimit"
            *ngIf="parentForm?.get(authControlKey)?.get('reprintLimit').value"
          >
            <input
              id="txtReprintLimit"
              matInput
              type="number"
              [placeholder]="'module-assignment.basket_settings.numberOfReprintAllowed' | translate"
              formControlName="numberOfReprintAllowed"
            />
          </mat-form-field>
        </div>
      </div>
      <!-- For Capture Reason code for Reprint toggle -->
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.capture_reason_code_for_reprint" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle
            id="matToggleCaptureReprintReason"
            formControlName="captureReprintReason"
          >
          </mat-slide-toggle>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.gift_receipt" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleGiftReceipt" formControlName="giftReceipt">
          </mat-slide-toggle>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.skip" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleReceiptSkip" formControlName="skip"> </mat-slide-toggle>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.both" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleReceiptBoth" formControlName="both"> </mat-slide-toggle>
        </div>
      </div>
    </mat-card-content>
    <mat-card-content style="padding-left: 40px;">
      <h4>{{"module-assignment.basket_settings.product_line_fields" | translate }}</h4>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.image_icon" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleImageIcon" formControlName="imageIcon"> </mat-slide-toggle>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.short_description" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleShortDescription" formControlName="shortDescription">
          </mat-slide-toggle>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.sku" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleSKU" formControlName="sku"> </mat-slide-toggle>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.long_description" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleLongDescription" formControlName="longDescription">
          </mat-slide-toggle>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.barcode" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleBarcode" formControlName="barcode"> </mat-slide-toggle>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.style" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleStyle" formControlName="style"> </mat-slide-toggle>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.color" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleColor" formControlName="color"> </mat-slide-toggle>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.size" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleSize" formControlName="size"> </mat-slide-toggle>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.categories_thread" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleCategoriesThread" formControlName="categoriesThread">
          </mat-slide-toggle>
        </div>
      </div>
    </mat-card-content>
    <mat-card-content style="padding-left: 40px;">
      <h4>{{"module-assignment.basket_settings.transaction_method_configuration" | translate }}</h4>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-bottom-3">
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          {{"module-assignment.basket_settings.disable_promotion" | translate }}
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
          <mat-slide-toggle id="matToggleDisablePromotion" formControlName="disablePromotion">
          </mat-slide-toggle>
        </div>
      </div>
      <table class="config-table">
        <thead>
          <tr>
            <th>Transaction Method</th>
            <th>Sale</th>
            <th>Refund</th>
            <th>Exchange</th>
            <th>Select All</th>
            <!-- <th>Disable Promotion</th> -->
          </tr>
        </thead>

        <tbody formArrayName="methods">
          <tr *ngFor="let method of methods.controls; let i = index" [formGroupName]="i">
            <!-- Method name -->
            <td>{{getTransactionLabel(method.get('transactionName')?.value)}}</td>

            <!-- Sale -->
            <td>
              <input type="checkbox" formControlName="sale" />
            </td>

            <!-- Refund -->
            <td>
              <label>
                <input type="checkbox" formControlName="partialRefund" />
                Partial Refund </label
              ><br />
              <label>
                <input type="checkbox" formControlName="fullRefund" />
                Full Refund </label
              ><br />
              <label>
                <input type="checkbox" formControlName="unreferencedRefund" />
                Unreferenced Refund
              </label>
            </td>

            <!-- Exchange -->
            <td>
              <label>
                <input type="checkbox" formControlName="exchange" />
                Exchange </label
              ><br />
              <label>
                <input type="checkbox" formControlName="unreferencedExchange" />
                Unreferenced Exchange
              </label>
            </td>

            <!-- Select All -->
            <td>
              <input type="checkbox" formControlName="selectAll" />
            </td>

            <!-- Disable Promotion -->
            <!-- <td>
              <input type="checkbox" formControlName="disablePromotion" />
            </td>
     -->
          </tr>
        </tbody>
      </table>
    </mat-card-content>
  </div>
</div>
